export const GET_BOWLINGCENTERPRODUCTSICON = 'GET_BOWLINGCENTERPRODUCTSICON';
export const GET_BOWLINGCENTERSEARCH = 'GET_BOWLINGCENTERSEARCH';
export const SUBMIT_CONTACTSFORM = 'SUBMIT_CONTACTSFORM';
export const GET_CONTACTSFORMINFO = 'GET_CONTACTSFORMINFO';
export const GET_QBASESNATIONLIST = 'GET_QBASESNATIONLIST';
export const GET_APPENDED_RESULTS = 'GET_APPENDED_RESULTS';
export const RESET_GET_APPENDED_RESULTS = 'RESET_GET_APPENDED_RESULTS';
